import { charterLinks } from 'components/Preview/help/links';
import { getAPIURL } from 'helper/helper';
import { colors } from 'theme/color-palette';

const apiURL = getAPIURL();
const { DARK_PURPLE } = colors;

export const STORE = 'Store';
export const OMNI = 'Omni';
export const SUPLR_STR_TMPT_ID = 403;
export const SUPLR_OMNI_TMPT_ID = 401;
export const CTMN_STR_TMPT_ID = 404;
export const CTMN_OMNI_TMPT_ID = 402;
export const STR_TMPT_LIST = [403, 404, 504, 604, 603];
export const OMNI_TMPT_LIST = [401, 402, 502];
export const DC_TMPT_LIST = [405, 406, 506, 606, 605];
export const STR_DEMAND_LIST = [412, 413, 511, 613, 612];
export const STR_ORDER_LIST = [410, 411, 510, 611, 610];
export const OTIF_TMPT_LIST = [414, 514];
export const HISTORICAL_REPORT_OMNI = [423, 424, 524];
export const VENDOR_SCORECARD_LIST = [801, 802, 901, 951, 952];
export const FY24_CANNED_REPORT_LIST = [1001, 1002, 1003];
export const VENDOR_SCORECARD_2025_LIST = [1004, 1005, 1006];
export const FUTURE_VALID_LIST = [1101, 1102, 1201, 1151, 1152];
export const CANNED_REPORT_LIST = [
	...VENDOR_SCORECARD_LIST,
	...VENDOR_SCORECARD_2025_LIST,
	...FY24_CANNED_REPORT_LIST
];
export const TENDER_ANALYSIS_LIST = [1301, 1302, 1401, 1351, 1352];
export const ECOMM_INSTOCK_LIST = [1701, 1702, 1801, 1751, 1752];
export const REGISTER_SALES_LIST = [421, 422, 521];
export const SHIP_TO_ZIP_LIST = [1501, 1502, 1551];
export const SELECTED_COLUMN_LIMIT = 250;
export const BOTTLE_DEPOSIT_IDS = [1601, 1602, 1501, 1502, 1551];
export const QUICK_ITEM_INFORMATION_IDS = [1703, 1704, 1802, 1753, 1754];
export const GENERAL_CANNED_REPORT_LIST = [
	...FUTURE_VALID_LIST,
	...TENDER_ANALYSIS_LIST,
	...SHIP_TO_ZIP_LIST,
	...ECOMM_INSTOCK_LIST,
	...QUICK_ITEM_INFORMATION_IDS
];
export const SHOW_AS_CANNED_REPORT = [
	...FUTURE_VALID_LIST,
	...CANNED_REPORT_LIST,
	...TENDER_ANALYSIS_LIST,
	...SHIP_TO_ZIP_LIST,
	...ECOMM_INSTOCK_LIST,
	...QUICK_ITEM_INFORMATION_IDS
];
export const ALL_LINK_ITEM_LIST = [...STR_TMPT_LIST, ...REGISTER_SALES_LIST];
/* IMPORTANT - DO NOT ADD STR_ORDER_LIST in below line otherwise it will break the shrink logic */
export const WK_SPEC_TMPT = [
	...STR_TMPT_LIST,
	...DC_TMPT_LIST,
	...STR_DEMAND_LIST,
	...STR_ORDER_LIST,
	...REGISTER_SALES_LIST,
	...HISTORICAL_REPORT_OMNI
];
export const ECOM_SALES_LIST = [701, 702];
export const ECOM_INVENTORY = [415, 416, 515, 615, 616];
export const MUMD_ORDER_LIST = [417, 418, 517, 617, 618];
export const MOD_TMPT_LIST = [408, 409, 509, 608, 609];
export const ENTERPRISE_INVENTORY = [419, 619, 519];
export const PURCHASE_ORDER_LIST = [420, 520];
// Catman has two sub personas, Category advisor and standard user.
// For Category advisor, the templateId sent by BE is 790.
// For Standard user, the templateId sent by BE is the same as supplier which is 789.
export const CATMAN_CUSTOM_DATASET_IDS = [789, 790];
// All custom dataset ids
export const ALL_CDS_IDS = [789, 790, 791, 792, 793];
export const STUDENT_CODE = '328582';
export const MTS_TEMPLATE_LIST_BASIC = [
	...STR_TMPT_LIST,
	...ECOM_SALES_LIST,
	...ECOM_INVENTORY,
	...DC_TMPT_LIST,
	...MUMD_ORDER_LIST,
	...REGISTER_SALES_LIST
];
export const MTS_TEMPLATE_LIST_CHARTER = [
	...STR_TMPT_LIST,
	...OMNI_TMPT_LIST,
	...ECOM_INVENTORY,
	...DC_TMPT_LIST,
	...MUMD_ORDER_LIST,
	...REGISTER_SALES_LIST
];

export const FUZZY_TMPT_LIST = [
	...REGISTER_SALES_LIST,
	...STR_TMPT_LIST,
	...OMNI_TMPT_LIST,
	...MUMD_ORDER_LIST,
	...ECOM_INVENTORY,
	...DC_TMPT_LIST,
	...OTIF_TMPT_LIST,
	...ECOM_SALES_LIST,
	...HISTORICAL_REPORT_OMNI
];

export const BYPASS_ROWCOUNT_LIST = [
	...REGISTER_SALES_LIST,
	...STR_TMPT_LIST,
	...OMNI_TMPT_LIST,
	...MUMD_ORDER_LIST,
	...ECOM_INVENTORY,
	...DC_TMPT_LIST,
	...OTIF_TMPT_LIST,
	...ECOM_SALES_LIST,
	...STR_DEMAND_LIST,
	...STR_ORDER_LIST,
	...TENDER_ANALYSIS_LIST,
	...SHIP_TO_ZIP_LIST,
	...QUICK_ITEM_INFORMATION_IDS,
	...ECOMM_INSTOCK_LIST,
	...HISTORICAL_REPORT_OMNI
];

export const SHOW_ADVANCED_OPTIONS_LIST = ['Trait Number'];
export const ADVANCED_OPTIONS = 'Advanced';
export const ADVANCED_TEMPLATES = [...STR_TMPT_LIST, ...ALL_CDS_IDS];

export const PROTIP_CDS_ATTR_LIST = [
	'mod traits',
	'modular traits',
	'eop',
	'end of period',
	'current',
	'send trait',
	'omit trait',
	'future send trait',
	'future omit trait',
	'future trait effective sate'
];

export const STR_INV_VIEW_LIST = [
	'STORE_DETAILS_WEEKLY',
	'STORE_DETAILS_DAILY',
	'STORE_DETAILS_WEEKLY_CATMAN',
	'STORE_DETAILS_DAILY_CATMAN',
	'BASIC_CATMAN_STORE_DETAILS_WEEKLY',
	'BASIC_CATMAN_STORE_DETAILS_DAILY',
	'BASIC_CATMAN_STORE_DETAILS_WEEKLY_MULTI_WINDOW',
	'BASIC_STORE_DETAILS_WEEKLY',
	'BASIC_STORE_DETAILS_DAILY',
	'BASIC_STORE_DETAILS_WEEKLY_MULTI_WINDOW'
];

export const INCOMPATIBILITY_ATTRIBUTE = [
	'Carry Option Code',
	'Carry Status Code',
	'Event Associated With Retail Price Amount'
];

export const INCOMPATIBILITY_BACKROOM_INVENTORY_ATTRIBUTES = [
	'Backroom Inventory Adjustment Type Code',
	'Backroom Inventory Adjustment Type Description'
];

export const CATALOG_ITEM_ID_INCOMPATIBILITY = 'Catalog Item ID';

/* Empty string is required to hide pin icon from 
   Purchase Order Time Period options as parent is 
   passed as '' <Empty String> from mongoDB 
*/
export const HIDE_PIN_ICON_FIELDS = [
	'customAttribute',
	'Walmart Calendar',
	'Gregorian Calendar',
	'Received Date',
	'Must Arrive By Date',
	'Scheduled Ship Date',
	''
];

export const DC_INV_VIEW_LIST = [
	'DC_INVENTORY_SALES_WEEKLY_CATMAN',
	'DC_INVENTORY_SALES_DAILY_CATMAN',
	'DC_INVENTORY_SALES_WEEKLY',
	'DC_INVENTORY_SALES_DAILY',
	'MERCHANT_DC_INVENTORY_CATMAN_DAILY',
	'MERCHANT_DC_INVENTORY_CATMAN_WEEKLY',
	'BASIC_CATMAN_DC_INVENTORY_SALES_WEEKLY',
	'BASIC_CATMAN_DC_INVENTORY_SALES_DAILY',
	'BASIC_CATMAN_DC_INVENTORY_SALES_WEEKLY_MULTI_WINDOW',
	'BASIC_DC_INVENTORY_SALES_WEEKLY',
	'BASIC_DC_INVENTORY_SALES_DAILY',
	'BASIC_DC_INVENTORY_SALES_WEEKLY_MULTI_WINDOW'
];
export const STR_ORDER_VIEW_LIST = [
	'STORE_ORDER_FORECAST_MERCHANT',
	'STORE_ORDER_FORECAST',
	'STORE_ORDER_FORECAST_CATMAN',
	'BASIC_STORE_ORDER_FORECAST',
	'BASIC_CATMAN_STORE_ORDER_FORECAST'
];

export const STR_DEMAND_VIEW_LIST = [
	'STORE_DEMAND_FORECAST_MERCHANT',
	'STORE_DEMAND_FORECAST',
	'STORE_DEMAND_FORECAST_CATMAN',
	'BASIC_CATMAN_STORE_DEMAND_FORECAST',
	'BASIC_STORE_DEMAND_FORECAST'
];
export const ECOM_INVENTORY_VIEW_LIST = [
	'ECOM_INVENTORY_SUPPLIER_DAILY',
	'ECOM_INVENTORY_CATMAN_DAILY',
	'MERCHANT_ECOM_INVENTORY_DAILY',
	'BASIC_ECOM_INVENTORY',
	'BASIC_CATMAN_ECOM_INVENTORY'
];
export const SCHEDULED_SHIP_DATE = 'Scheduled Ship Date';
export const MUST_ARRIVE_DATE = 'Must Arrive By Date';
export const RECEIVED_DATE = 'Received Date';
export const MULTI_TIME_PIVOT_TEXT = '';
export const PO_TIME_PERIOD_ARRAY = [SCHEDULED_SHIP_DATE, MUST_ARRIVE_DATE, RECEIVED_DATE];
export const PO_TIME_PERIOD = {
	SCHEDULED_SHIP_DATE,
	MUST_ARRIVE_DATE,
	RECEIVED_DATE
};
export const PO_DATE_LIST = {
	wmtCalendar: 'Walmart Week',
	poCreateDay: 'PO Create Date',
	poShipDate: 'Do Not Ship Before Date',
	mustArriveDate: 'Must Arrive By Date',
	receivedDate: 'Received Date'
};

export const PO_DISABLE_CUSTOM_FUTURE_DATE = [PO_DATE_LIST.poCreateDay, PO_DATE_LIST.receivedDate];
export const member = [
	'Date',
	'Week',
	'Month',
	'Quarter',
	'Year',
	'Day',
	'Walmart Week',
	'PO Create Date',
	'Do Not Ship Before Date',
	'Must Arrive By Date',
	'Received Date'
];
export const CURRENT_PLAN = 'Your current plan is';
export const LUMINATE_BASIC = ' Scintilla Basic';
export const LEARN_MORE_PLANS = 'Learn about a Charter subscription';
export const PERIOD = '.';
export const USE_THIS_TEMPLATE = 'Build Report';
export const CANCEL_BUTTON = 'Cancel';
export const SAVE_BUTTON = 'Save';
export const HEADER_PART_ONE = 'Choose a';
export const HEADER_PART_TWO = 'dataset';
export const HEADER_PART_THREE = 'to start.';
export const WELCOME = 'Welcome';
export const WELCOME_MSG =
	'Channel Performance Report Builder enables users to create, schedule and share a report using predefined templates. User can choose to create a report with no template from the ground up with available dimensions and measures.';
export const LETS_GET_STARTED = "Let's get started!";
export const DIMENSION = 'DIMENSIONS';
export const DIMENSION_ASTRK = 'Dimension*';
export const PARENT_CUST_ATTR = 'customAttribute';
export const MEASURES = 'METRICS';
export const TIME = 'Time period';
export const CLEAR_ALL = 'Clear All';
export const CLEAR_ALL_CAPITALIZE = 'Clear all';
export const PREVIEW = 'Preview';
export const SCHEDULE = 'Schedule';
export const PREVIEW_CLICK_MSG = "Click 'Preview' to see the result";
export const PREVIEW_LOADING_MSG = 'Please wait while Preview loading...';
export const NETWORK_ISSUE_MSG = 'Network Issue. Please try again.';
export const PIVOT_WARNING_MSG =
	'When pivoting time ranges across columns, select your data and time ranges in the order you need in your final report. Rearranging (drag-drop) of columns when pivoting across time ranges is currently not enabled.';
export const REPORT = 'Create Report';
export const REPORT_FORMAT = 'Report Format';
export const RUN_ONCE = 'Run Once';
export const RUN_CONT = 'Run Continuously';
export const NOTIFY = 'Notify via Email when complete';
export const CREATE = 'Create';
export const QUARTER_TOOLTIP =
	"Walmart's fiscal year running from Feburary 1st to January 31st of the following year.";
export const COUNT_MSG = 'Calculating the row count  ';
export const LIMIT_EXCEEEDED = '(Excel row limit exceeded)';
export const GO_HOME = 'Go Home';
export const DAILY = 'Daily';
export const WEEKLY = 'Weekly';
export const MONTHLY = 'Monthly';
export const QUARTERLY = 'Quarterly';
export const ONCE = 'Once';
export const ALL = 'All';
export const NOW = 'Now';
export const TODAY = 'Today';
export const OCCURRED = 'Error occurred';
export const LATER = 'Later';
export const LAST_DATE = 'Last Day of Month';
export const NEXT_EXECUTION_TIME = 'Next execution time';
export const SCHEDULE_ERROR = 'Please select the schedule';
export const END_DATE_ERROR = 'Please provide a valid end date';
export const OCCURRENCE_ERROR = 'Please provide a valid occurrence';
export const REPORT_NAME_ERROR = 'Please enter the report name';
export const INVALID_DRAFT_NAME = 'Please enter the draft name';
export const REPORT_NAME_EXISTS = 'Report name already exists';
export const DRAFT_NAME_EXISTS = 'Draft name already exists';
export const BAD_CHARACTER_SET = 'Cannot contain: &, *, <,  >, /, \\, ", \', [, ] and ,';
export const STATUS = 'Status';
export const TEMPLATE = 'Dataset';
export const NAME = 'Name';
export const REPORT_NAME = 'reportName';
export const DRAFT_NAME = 'draftName';
export const TEMPLATE_NAME = 'templateName';
export const STATUS_LOWER = 'status';
export const FREQUENCY = 'Frequency';
export const FREQUENCY_LOWER = 'frequency';
export const LAST_RUN_TIME = 'Last run time';
export const LAST_RUN_DATE = 'lastRunDate';
export const LAST_UPDATED_DATE = 'lastUpdatedDate';
export const PURGE_DATE = 'purgeDate';
export const EXPIRATION_DATE = 'Expires on';
export const FILE_TYPE = 'File type';
export const DOWNLOAD = 'Download';
export const DOWNLOAD_AGAIN = 'Download again';
export const EDIT = 'Edit';
export const DELETE = 'Delete';
export const TOOLTIP_NAME = 'NAME';
export const DESCRIPTION = 'DESCRIPTION';
export const NO_RESULT_FOUND_MSG = 'No Results Found. Try a different keyword.';
export const NO_MATCH =
	'No result found. Please try different keywords. If you believe there’s error, please contact us.';
export const MAX_SELECTED_COLUMNS =
	'Max Selected Columns has been reached, Please create your report.';
export const DELETE_DIALOG_ONCE = 'Are you sure you want to delete?';
export const DELETE_DIALOG_ALL = 'Are you sure you want to delete this scheduled report?';
export const DELETE_SUB_HEADING = 'This is a scheduled recurring report.';
export const DELETE_ONCE_COMPLETED =
	'Deleting this report will terminate the scheduled job for future report execution.';
export const ONLY_REPORT = 'Only this report';
export const ALL_REPORT = 'This and following reports';
export const DOWNLOAD_START_MSG = 'Download will start shortly. Please wait for a while.';
export const OK = 'Ok';
export const OKAY = 'Okay';
export const NEW_EXCLAMATION = 'New!';
export const NEW_REPORT = 'New Report';
export const FILTER = 'Filters';
export const FILTER_LOWER = 'filter';
export const TIME_LAG = '*OTIF data has two weeks (including current week) lag';
export const REPORT_INFO = 'Report information';
export const BACK_WARN_NOTE = 'Note: Your data will be lost';
export const BACK_WARN_MSG =
	'Are you sure you want to leave? You will lose your current report if you continue!';
export const CONTINUE = 'Continue';
export const CSV_ROWS_EXCEED = 'File size limit exceeded';
export const ZERO_ROWS = 'Row count: 0';
export const CSV_ROWS_EXCEED_TOOLTIP =
	'You cannot create a report with 10 million rows. Please go back to edit your report.';
export const ZERO_ROWS_TOOLTIP =
	'You cannot create a report with zero row. Please go back to edit your report.';
export const CALCULATING = 'Calculating...';
export const RELOAD = 'Reload';
export const SUPPORT = 'Contact support';
export const NO_DATA =
	'Seems like there is no data for your report. Try selecting some other column and/or change the filter(s)';
export const DEFAULT_ERR_MSG = 'Sorry, something went wrong on our end.';
export const ECOM_ONLY_FLAG = 'ecomOnlyFlag';
export const MERCHANT_ONLY_FLAG = 'merchantOnlyFlag';
export const ECOM_ONLY = 'eCom only';
export const MERCHANT_ONLY = 'Merchant only';
export const ALIAS = 'ALIAS';
export const REPORT_SETTINGS_ERROR_MSG =
	'Sorry, Something went wrong at our end. Please go back and try again.';
export const UPDATE = 'Update';
export const PREVIEW_MSG =
	'Preview is limited to max 50 rows from last 7 days of your time selection. For a complete data set, please schedule and download the report.';
export const OMNI_ALERT =
	'Please select both eCom and Store attributes in order to view OMNI report to avoid seeing BLANK metrics attributions.';
export const OMNI_FAQ_LINK = (
	<a
		rel="noreferrer"
		href={`${apiURL}/knowledgeBase/article/content/?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/chp-resources/chp-faqs/en_us/chp-faqs`}
		target="_blank">
		{'FAQ'}
	</a>
);
export const FORMATTED_OMNI_ALERT = (
	<>
		{OMNI_ALERT} Go to {OMNI_FAQ_LINK} to learn more.
	</>
);
export const PORTAL_CONTEXT = 'PORTAL_CONTEXT';
export const SHOW_REPORT_EXPIREING_ALERT = 'SHOW_REPORT_EXPIREING_ALERT';
export const OMNI_BUNDLESELECT_MAP = new Map([
	['future_effective_date', ['future_vendor_pack_cost_amount']],
	['future_vendor_pack_cost_amount', ['future_effective_date']]
]);
export const MANDATE_FILTER_MSG = 'Please apply at least 1 filter on Dimension';
export const REQUIRED_FILTER_MSG = 'Please select one required filter condition';
export const REPORT_SHARE_MSG =
	'Please share report with caution. Recurring reports will continue to be shared until access is revoked.';
export const NO_REPORTS_PROJECT =
	'Real data, revealing insights - Build and Schedule custom reports.';
export const NO_REPORTS_PROJECT_BASIC = 'Real data. Revealing answers.';
export const NO_REPORTS_SHARED = 'Currently, there are no shared reports.';
export const WELCOME_TEXT_TWO = 'Click New report to begin.';
export const TOOLTIP_SHOW_MSG = 'Do not show this message again';
export const TOOLTIP_TEMPLLATE_MSG =
	'This panel is for you to review the data elements in selected template.';
export const END_REPORT = 'End Report';
export const CUSTOM_ATTRIBUTE = 'Custom attribute';
export const SHARED = 'Shared';
export const PROJECTS = 'Projects';
export const LEAVE = 'Leave report';
export const CREATE_COPY = 'Create a copy';
export const RUN_NOW_MESSAGE = `We are scheduling your new report! This should only take 10-15 minutes.
Once your report has been scheduled, you can use 'Run Now' anytime for immediate results.`;
export const GOT_IT_BTN = 'Got It';
export const QUICK_REPORT = 'Quick Report';
export const VENDOR_SCORECARD = 'Vendor Scorecard';
export const BUILD_REPORT = 'Build a report';
export const FROM_SCRATCH = 'from scratch';
export const BUILD_TO_TRACK = 'Build a report ';
export const NO_FILTER = 'No filters selected.';
export const TIME_FILTER_REQ = 'Time filter is required to build report.';
export const DISP_REPORT_COL = 'Display as report column';
export const CUSTOMIZE = 'Customize';
export const RUN = 'Run';
export const NO_TEMP_MSG_ONE = 'No quick reports available now.';
export const BASIC_NO_TEMP_MSG_ONE = 'No quick reports available.';
export const NO_TEMP_MSG_TWO =
	'	We are working on adding quick reports for this dataset in future releases, please proceed with building a report from scratch in the meantime.';
export const VENDOR_SCORECARD_PREVIEW_HEADER = 'To build a Vendor Scorecard report:';
export const VENDOR_SCORECARD_PREVIEW_DIM = 'Apply filter on at least';
export const VENDOR_SCORECARD_PREVIEW_DIM_STYLED = '1 Dimension';
export const VENDOR_SCORECARD_PREVIEW_METRIC = 'and keep';
export const VENDOR_SCORECARD_PREVIEW_METRIC_STYLED = '1 Metric';
export const VENDOR_SCORECARD_PREVIEW_METRIC_SELECTED = 'selected';
export const VENDOR_SCORECARD_PREVIEW_VEN_NUM = 'Try';
export const VENDOR_SCORECARD_PREVIEW_VEN_NUM_STYLED = 'Vendor Name / Vendor Number';
export const VENDOR_SCORECARD_PREVIEW_VEN_NUM_NORMAL = 'for a standard scorecard';
export const VENDOR_SCORECARD_PREVIEW_READY = 'Your report is ready to be scheduled';
export const VENDOR_SCORECARD_COMING_SOON = 'Preview is coming soon...';
export const BASIC = 'BASIC';
export const CHARTER = 'CHARTER';
export const VENDOR_SCORECARD_VALIDATING_REPORT = 'Validating report ';
export const VENDOR_SCORECARD_VALIDATED_REPORT = 'Report validated';
export const VENDOR_SCORECARD_MAX_ROW_COUNT = 15000;
export const VENDOR_SCORECARD_MAX_ROW_COUNT_TOOLTIP =
	'Excel row limit exceeded, if you proceed with scheduling report it will have truncated data else please go back and edit your filters';
export const VENDOR_SCORECARD_ROW_COUNT_TIMEOUT =
	'Calculating row count is taking too long, the report might have truncated data if the excel row limit is exceeded';
export const COLUMNS = 'Columns';
export const COLUMNS_LOWER = 'columns';
export const LINK_ITEM_ACTIVITY = 'linkItemActivity';
export const LINK_ITEMS_ACTIVITY = 'linkItemsActivity';
export const DATA_IN_USE = 'Data in Use';
export const MORE_DATA_AVAILABLE = 'More data available in Customize';
export const CHARTER_ONLY_TAG = 'Charter only';
export const CHARTER1 = 'Charter';
export const ONLY = ' only';
export const CHARTER_ONLY_DATA = 'CHARTER ONLY DATA';
export const LEARN_MORE = 'Learn more';
export const OPTIONS = ['Save and Exit'];
export const MENU = [UPDATE, CREATE_COPY];
export const LAST_UPDATED = 'Last update';
export const DRAFT_SAVED = 'Report added to Saved';
export const DRAFT_ERROR_MSG =
	'Report cannot be saved due to connection issue. Please try again later.';
export const DRAFT_LIMIT_ERROR = 'Report cannot be saved since your save storage is full.';
export const MY_REPORTS_TAB_TEXT = 'My Reports';
export const SHARED_WITH_ME_TAB_TEXT = 'Shared with me';
export const ALERT_FOR_EPIRING_REPORTS = 'You have reports expiring in 3 days.';
export const BTN_TO_SEE_EXPIRING_REPORTS = 'View expiring reports';
export const BTN_TO_SEE_EXPIRING_REPORTS_TOOLTIP = `Please make sure you have downloaded/ saved the report before it’s expired.`;
export const RENAME = 'Rename';
export const ADD_TO_SAVED = 'Add to saved';
export const RUN_NOW = 'Run now';
export const RUN_AGAIN = 'Run again';
export const PREVIEW_TOOLTIP_FOR_BASIC =
	'Preview enables users to review the top 50 rows of data for accuracy before creating a report.';
export const MTS_HEADER = 'Multi time selection';
/**
 * Pinned Attribute
 */
export const PIN_MAX_LIMIT = 100;
export const PINNED_DATA = 'Pinned data';
export const PIN_MAX_LIMIT_MESSAGE = "Limit reached. Can't pin more items.";
export const PIN_MAX_LIMIT_TOOLTIP = `Pin Limit Reached! You can only pin up to ${PIN_MAX_LIMIT} data.`;

/**
 * Share report component
 */
export const SHARE = 'Share';
export const SHARE_REPORT_TITLE = 'Share report';
export const SHARE_SEARCH_PLACEHOLDER = 'Search name';
export const SHARED_WITH = 'Shared with:';
export const INVITES = 'Invites';
export const OWNER = 'Owner';
export const VIEWER = 'Viewer';
export const REMOVE_ACCESS = 'Remove access';
export const SAVE_CHANGES = 'Save changes';
export const SAVE_SUCCESSFUL = 'Dataset Saved';
export const DELETE_SUCCESSFUL = 'Dataset deleted';
export const DATASET_EXISTS = 'Dataset Already Exists';
export const SEND = 'Send';
export const MESSAGE = 'Message';
export const OPTIONAL = 'Optional';
export const ALREADY_INVITED_ERROR = 'User has already been invited';
export const REPORT_SUCCESSFULLY_SHARED = 'Report successfully shared';
export const DISMISS = 'Dismiss';
export const DISCARD = 'Discard';
export const DISCARD_WARNING = 'Discard unsaved changes?';
export const SHARING_SETTINGS_SAVED = 'Report sharing settings saved.';
export const ERROR_WITH_SHARING_API =
	'We are facing error while updating sharing settings for the report';
export const MERCHANT_TAG = 'Merchant';
export const WMT_OTHER_TAG = 'WMT Other';
export const SUPPLIER_TAG = 'Supplier';
export const CATMAN_TAG = 'Category Advisor';
export const STANDARD_TAG = 'Standard User';
export const NO_MATCHING_RESULT = 'No matching result';
export const TRY_SOMETHING_ELSE = 'Please try something else';
export const USER_LIST_API_FAILURE = 'Something went wrong.';
export const USER_LIST_API_FAILURE_SUPPORT = 'Please try again or contact Scintilla support';
export const WALMART = 'Walmart';
export const DATA_VENTURES = 'Data Ventures';
export const DRAFT_NAME_TITLE = 'Name before saving';
export const DRAFT_NAME_CONTENT = 'Give your untitled report a name before it is saved:';
export const DRAFT_SAVE_TITLE = 'Do you want to save your changes?';
export const DRAFT_SAVE_CONTENT = "Your changes will be lost if you don't save them.";
export const DONT_SAVE = "Don't Save";
export const DONT_SAVE_2 = "Don't save";
export const SAVE_DATASET = 'Save dataset';
export const SAVE_AS_NEW_DATASET = 'Save as new dataset';
export const DELETE_DATASET_MODAL_TITLE = 'Delete custom dataset';
export const DELETE_DATASET_BTN_TEXT = 'Delete dataset';
export const DELETE_DATASET_MSG_1 = 'Are you sure you want to delete';
export const DELETE_DATASET_MSG_2 = '? Once deleted, the dataset cannot be recovered.';
export const DELETE_DATASET_REPORT_MSG =
	'You will not be able to edit the following reports created from this dataset:';
export const NAME_YOUR_DATASET = 'Name your dataset';
export const DATASET_NAME_MAXLENGTH = 25;
export const NAME_EXISTED = 'Name existed';
export const INCLUDE_DATA = 'Include data';
export const EXCLUDE_DATA = 'Exclude data';
export const RECIPE_ONLY_TITLE = 'Recipe only (no data)';
export const RECIPE = 'Recipe';
export const EXT_USERS_TAG = '[EXT]';
export const DISABLE_INCLUDE_DATA_TOOLTIP = `The selected recipients do not have access to your report’s data values. Only report recipe will be shared.`;
export const INCLUDE_DATA_HELP = `Enabling ‘Include data’ grants your recipient access to all data values in this shared report.`;
export const VSC_TO_CATMAN_ERROR =
	'Currently Vendor Scorecard report cannot be shared with Category Advisors';
export const CDS_NO_DATA = 'Nothing turned up';
export const CDS_NO_DATA_TEXT1 = 'You may want to try using different keywords,';
export const CDS_NO_DATA_TEXT2 = 'checking for typos, or adjusting your filters.';
export const CDS_NO_DATA_TEXT3 = `Didn't find what you are looking for?`;
export const GIVE_FEEDBACK = `Give Feedback`;
export const INCLUDEDATA = 'includeData';
export const EXCLUDEDATA = 'excludeData';
export const REMOVEACCESS = 'removeAccess';
/**
 | Filter Constanst 
 */
export const NO_FILTER_SELECTED = `You haven't applied any filter yet.`;
export const FORM_SEL_CONDITION_LBL = 'Condition';
export const FORM_SEL_COLUMN_LBL = 'Select a column';
export const DFLT_COLUMN_TXT = 'Where';
export const LOADING_MSG = 'Data is loading, this may take a moment';
export const TIME_PERIOD = 'Time Period';
export const WEEKDAYS_ONLY = 'Weekdays only';
export const WEEKENDS_ONLY = 'Weekends only';
export const SPECIFIC_WEEK = 'In specific days of the week';
export const EVERY_MONTH = 'of every month';
export const MONTH_QUARTER = 'month of quarter';
export const DAY_MONTH = 'day of month';
export const SCHEDULED = 'SCHEDULED';
export const RUNNING = 'RUNNING';
export const COMPLETED = 'COMPLETED';
export const FAILED = 'FAILED';
export const INACTIVE = 'INACTIVE';
export const DELETED = 'DELETED';
export const NO_DATA_FOUND = 'NO_DATA_FOUND';
export const BOT_MODAL_FILTER_MSG = 'Please re-select the current filter';
export const FILTER_FROM_ALL_DATA = 'filterFromAllData';
export const EDIT_FILTER_FROM_COLUMNS = 'editFilterFromColumns';
export const DATE_REFRESH_TIME_TIP =
	'For this dataset, data refreshed time is based on your selected time period or applied time filter.';
export const DATA_REFRESHED = 'Data refreshed:';
export const LANDINGS = {
	prod: apiURL,
	preprod: apiURL,
	stage: apiURL,
	dev: apiURL
};

export const WEEKDAYS = [
	{ label: 'Mon' },
	{ label: 'Tue' },
	{ label: 'Wed' },
	{ label: 'Thu' },
	{ label: 'Fri' },
	{ label: 'Sat' },
	{ label: 'Sun' }
];

export const WEEKS = [
	{ keyName: 'Custom', value: SPECIFIC_WEEK },
	{ keyName: 'Weekdays', value: WEEKDAYS_ONLY },
	{ keyName: 'Weekends', value: WEEKENDS_ONLY }
];

/**
 * Preview Dialog
 */
export const DIALOG_TITLE = 'Note: Preview may take longer';
export const DIALOG_CONTENT = `It may take a little longer to preview the data without applying any filter on dimensions/metrics. Do you want to continue?`;
export const KEEP_PREVIEW = 'Preview anyway';
export const DIALOG_TITLE_SSI = 'Filter error';
export const APPLY_FILTER = 'Cancel';
export const CANCEL = 'Cancel';
export const REMOVE_ANYWAY = 'Remove anyway';
export const BLOCKED_PREVIEW_DIALOG_CONTENT =
	'Note: Please apply at least one filter to your dimensions. Failure to apply a filter may delay or impede report generation.';
export const BLOCKED_PREVIEW_DIALOG_CONTENT_SSI =
	'Please apply filter to at least one Dimension, (e.g.: Store number, Item number), without using ‘is null’ or ‘is not null’ as condition.';

/**
 *  Schedule Report
 */
export const TIMED_OUT_COUNT = -1;
export const MAX_ROW_COUNT = 1048576;
export const MAX_CSV_ROW_COUNT = 10000000;
export const CSV_FILE_TYPE = '.CSV';
export const XLXS_FILE_TYPE = '.XLSX';
export const REFRESH_TIME = 60000;
export const MAX_REFRESH_COUNT = 10;
export const SAVED_TAB = 0;
export const SHARED_TAB = 0;
export const REPORT_NAME_MAX_LENGTH = 50;
export const MAX_SAVE_DRAFT = 500;
export const WARNING_TO_CHANGE_TO_CSV =
	'Please use CSV to schedule your report as the responding time is too long';
export const WARNING_ROW_LIMIT_EXCEED =
	'*A .CSV file will be generated if report data reaches excel limit';
export const WARNING_MAX_REPORT_CREATION = `You have exhausted your max report creation/run limit for the day as per the 'Basic' plan, please schedule report for later.`;
export const Bogle_Regular = 'Bogle-Regular';
export const Bogle_Medium = 'Bogle-Medium';
export const Bogle_Light = 'Bogle-Light';
export const DOT_SPACING = 25;
export const Space_Between = 'space-between';

export const CUSTOM = 'Custom';
export const OMNI_SALES = 'OMNI_SALES';
export const OMNI_SALES_CATMAN = 'OMNI_SALES_CATMAN';
export const MERCHANT_OMNI_CATMAN = 'MERCHANT_OMNI_CATMAN';
export const CATMAN = 'CATMAN';
export const L_FILE_DOWNLOAD_MSG =
	'Due to the size of this report, it is zipped with .zip extension.';
export const CHARTER_DELETE_MSG = 'This report will be deleted in 15 days after running.';
export const BASIC_DELETE_MSG = 'This report will be deleted in 7 days after running.';
export const DAILY_SCHEDULE_TOOLTIP =
	'The Daily is disabled because your report is built on weekly data';
export const WEEKEND_GUIDE_TOOLTIP =
	"Just FYI, weekly data refresh completes on Sunday. You're suggested to schedule reports after Sunday AM hours to pull last week's data.";
export const DAYS = {
	Sun: false,
	Mon: false,
	Tue: false,
	Wed: false,
	Thu: false,
	Fri: false,
	Sat: false
};
export const BASIC_SSI_TOOLTIP_MAX_COUNT = 'Max row count: 10,000,000';
export const BASIC_SSI_TOOLTIP_ALLOWED_TEMP =
	'(Row count check is only applicable to Store Sale and Inventory dataset)';
export const BASIC_SSI_TOOLTIP_INVALID_REPORT =
	'Report cannot be created at this point. Please apply more filter to reduce the file size.';
export const CHARTER_TOOLTIP_MAX_COUNT = 'Estimated Row Count';
export const CHARTER_TOOLTIP_ALLOWED_TEMP =
	'The displayed row count is an estimate based on your selected columns and filters.';

/**
 * Adobe analytics
 */
export const ADOBE_URL = {
	prod: 'https://assets.adobedtm.com/54ac91b83be6/129d6c3d4b54/launch-3ee40c545cb2.min.js',
	'non-prod':
		'https://assets.adobedtm.com/54ac91b83be6/129d6c3d4b54/launch-5197731fa672-development.min.js'
};

/**
 * Filter condition labels
 */
export const FILTER_CONDITION_LABELS = {
	TODAY: 'Current Date',
	IS_EQUAL_TO: 'is equal to',
	IS_NOT_EQUAL_TO: 'is not equal to',
	CONTAINS: 'contains',
	DOES_NOT_CONTAIN: "doesn't contain",
	START_WITH: 'start with',
	DOES_NOT_START_WITH: "doesn't start with",
	ENDS_WITH: 'ends with',
	DOES_NOT_END_WITH: "doesn't end with",
	IS_NULL: 'is null',
	IS_NOT_NULL: 'is not null',
	IS_GREATER_THAN: 'is greater than',
	IS_GREATER_THAN_OR_EQUAL_TO: 'is greater than or equal to',
	IS_LESS_THAN: 'is less than',
	IS_LESS_THAN_OR_EQUAL_TO: 'is less than or equal to',
	IS_IN_BETWEEN: 'is in between',
	YESTERDAY: 'Yesterday',
	WMT_WEEK_TO_DATE: 'WMT Week to date',
	WMT_LAST_WEEK: 'WMT Last week',
	WMT_LAST_2_WEEKS: 'WMT Last 2 weeks',
	WMT_LAST_4_WEEKS: 'WMT Last 4 weeks',
	MONTH_TO_DATE: 'Month to date',
	WMT_MONTH_TO_DATE: 'WMT Month to date',
	CUSTOM: 'Custom',
	SELECT_ALL: 'Select All',
	WMT_YEAR_TO_DATE: 'WMT Year to date',
	WMT_LAST_13_WEEKS: 'WMT Last 13 weeks',
	WMT_LAST_26_WEEKS: 'WMT Last 26 weeks',
	WMT_LAST_52_WEEKS: 'WMT Last 52 weeks',
	WMT_LAST_104_WEEKS: 'WMT Last 104 weeks',
	WMT_QUARTER_TO_DATE: 'WMT Quarter to date',
	WMT_LAST_QUARTER: 'WMT Last quarter',
	WMT_LAST_2_QUARTERS: 'WMT Last 2 quarters',
	WMT_LAST_4_QUARTERS: 'WMT Last 4 quarters',
	WMT_YEAR_TO_DATE_CURR_YR: 'CURR_YR (WMT Year to date)',
	WMT_YEAR_PREV_YR: 'PREV_YR(WMT Year)',
	WMT_LAST_YEAR: 'WMT Last Year',
	WEEK_TO_DATE: 'Week to date',
	QUARTER_TO_DATE: 'Quarter to date',
	LAST_WEEK: 'Last week',
	LAST_2_WEEKS: `Last 2 weeks`,
	LAST_4_WEEKS: 'Last 4 weeks',
	LAST_13_WEEKS: 'Last 13 weeks',
	LAST_26_WEEKS: 'Last 26 weeks',
	LAST_52_WEEKS: 'Last 52 weeks',
	LAST_104_WEEKS: 'Last 104 weeks',
	LAST_156_WEEKS: 'Last 156 weeks',
	LAST_MONTH: 'Last month',
	LAST_2_MONTHS: 'Last 2 months',
	LAST_3_MONTHS: 'Last 3 months',
	LAST_6_MONTHS: 'Last 6 months',
	LAST_12_MONTHS: 'Last 12 months',
	LAST_QUARTER: 'Last quarter',
	LAST_2_QUARTERS: 'Last 2 quarters',
	LAST_4_QUARTERS: 'Last 4 quarters',
	YEAR_TO_DATE_CURR_YR: 'CURR_YR (Year to date)',
	CURRENT_WEEK: 'Current week',
	YEAR: 'PREV_YR',
	WMT_CURR_WK: 'WMT Current week',
	WMT_NXT_WK: 'WMT Next week',
	WMT_NXT_2_WK: 'WMT Next 2 weeks',
	WMT_NXT_4_WK: 'WMT Next 4 weeks',
	WMT_NXT_13_WK: 'WMT Next 13 weeks',
	WMT_NXT_26_WK: 'WMT Next 26 weeks',
	WMT_NXT_39_WK: 'WMT Next 39 weeks',
	WMT_NXT_52_WK: 'WMT Next 52 weeks',
	WMT_NXT_104_WK: 'WMT Next 104 weeks',
	NEXT_WK: 'Next week',
	NEXT_2_WK: 'Next 2 weeks',
	NEXT_4_WK: 'Next 4 weeks',
	NEXT_13_WK: 'Next 13 weeks',
	NEXT_26_WK: 'Next 26 weeks',
	NEXT_39_WK: 'Next 39 weeks',
	NEXT_52_WK: 'Next 52 weeks',
	ON: 'On',
	AFTER: 'After',
	BEFORE: 'Before',
	WEEKEND: 'Last Weekend [Fri-Sat-Sun]',
	HAS_ANY_OF: 'has any of',
	HAS_ALL_OF: 'has all of',
	WMT_LY_LAST_4_WEEK: 'WMT LY Last 4 weeks',
	WMT_LY_LAST_13_WEEK: 'WMT LY Last 13 weeks',
	WMT_LY_LAST_26_WEEK: 'WMT LY Last 26 weeks',
	WMT_LY_LAST_52_WEEK: 'WMT LY Last 52 weeks',
	WMT_LLY_LAST_4_WEEKS: 'WMT LLY Last 4 weeks',
	WMT_LLY_LAST_13_WEEKS: 'WMT LLY Last 13 weeks',
	WMT_LLY_LAST_26_WEEKS: 'WMT LLY Last 26 weeks',
	WMT_LLY_LAST_52_WEEKS: 'WMT LLY Last 52 weeks',
	// LY_LAST_MONTHS: 'LY Last Months',
	// LY_LAST_3_MONTHS: 'LY Last 3 months',
	// LY_LAST_6_MONTHS: 'LY Last 6 months',
	// LY_12_MONTHS: 'LY Last 12 months',
	// LLY_LAST_MONTHS: 'LLY Last months',
	// LLY_LAST_3_MONTHS: 'LLY Last 3 months',
	// LLY_LAST_6_MONTHS: 'LLY Last 6 months',
	// LLY_12_MONTHS: 'LLY Last 12 months',
	LAST_6_YEARS: 'Last 6 years'
};
export const ATTRIBS_LOWERCASE = {
	dimensions: 'dimensions',
	measures: 'measures',
	customAttribute: 'customAttribute'
};
export const ATTRIBS = {
	dimensions: DIMENSION,
	measures: MEASURES
};
/* Order Demand Forecast Dimension*/
export const WM_YR_WK_NO = 'Walmart Year Week Number';
export const WM_ITEM_NBR = 'wm_item_nbr';

/** Order Forecast Dimensions */
// export const SCH_ARR_DT = ['Scheduled Arrival Date'];
// export const SUG_ORD_DT = ['Suggested Order Date'];
export const OTH_ORD_FRCT_DT = [
	'Scheduled Arrival Date',
	'Order Place Date',
	'Need Ship Date',
	'Scheduled Ship Date',
	'Need Arrival Date'
];

/** Order Forecast template has 4 attributes with fuzzy options */
export const STR_ORDER_FIELDS_WITH_FUZZY = [
	'Scheduled Arrival Date',
	'Order Place Date',
	'Need Arrival Date',
	'Need Ship Date'
];

/** Shrink Window */
export const SHRINK_WINDOW_RANGE = 6;
export const CUSTOM_DT_DIM = ['Custom', 'On', 'After', 'Before'];
export const DT_DIM_EX_CUSTOM = ['On', 'After', 'Before'];
export const FILTER_BY = 'Filter by';
export const SORT_BY = 'Sort by';
export const REPORT_SPECIAL_KEYS = ['Tab', 'Shift', 'ArrowUp', 'ArrowDown'];
export const REPORTS = 'Reports';
export const TEMPLATE_TABS = ['Dataset', 'Reports'];
export const TEMPLATE_TABS_WITHOUT_CANNED_REPORTS = ['Dataset'];

/**
 * | Feedback URL - Survey - AIRTABLE
 */
export const RB_FEEDBACK_URL = `https://airtable.com/shrYrDYfgScAemupi`;
export const FEEDBACK_BTN_TXT = 'Feedback';

export const BASICUSERS = ['BASIC_VENDOR'];
/**
 * | Metadata
 */
export const VIEW_ALL = 'View all';
export const VIEW_LESS = 'View less';
export const MAX_FILTER_VALUE_TO_BE_SHOWN = 100;

/**
 * Order template Message
 */

export const ORDER_TMPL_MSG = `For item->DC level forecasting data, please use 'DC/Store Number' as your DC number and apply mandatory filter 'Distribution Center Number’ = 0.`;

/**
 * When filter values are > 200
 */
export const MAX_FILTER_VALUE = 200;
export const MAX_INT_FILTER_VALUE = 5000;
export const EXCEED_MAX_LIMIT = ' Values exceed limit are missing';
export const EDIT_FILTER_VALUE = 'Edit filter value';
export const SEARCH_FILTER_PLACEHOLDER = 'Search';
export const SELECT_ALL_FILTER_VALUES = 'Select all';
export const TOOLTIP_ADD_NEW_FILTER_VAL =
	'For adding multiple values at once, please edit at Filter panel.';
export const ADD_FILTER_VAL = 'Add ';
export const CANNOT_ADD_FILTER_VAL = ' Cannot add ';
export const NO_FILTER_VALUES = 'No values, please go back to add values';
export const GO_BACK_TO_FILTER = 'Back to Filter';
export const VALIDATION_ERROR_MSG = 'Please only input numeric data (1,2,3,4...)';
export const INVALID_VALUE = 'is invalid, please try other values.';

/**
 * | All link item num
 */
export const LINK_ITEMS_NUM_BTN_TEXT = 'Linked Items Activity';
export const APPLY = 'Apply';
export const CLEAR = 'Clear';
export const NONE = 'None';
export const NO_LINKED_ACTIVITY = 'No Linked Items Activity applied';
export const ALL_LINK_ROLLUP = 'All Links Rollup';
export const ALL_LINK_ROLLUP_DESC =
	'All parent and children Walmart item numbers in a cross-reference chain will be rolled up as a single sum to the Prime Walmart item number and reported on.';
export const ALL_LINK_ROLL_DETAIL = 'All Links Detail';
export const ALL_LINK_ROLL_DETAIL_DESC =
	'All parent and children Walmart item numbers in a cross-reference chain will be shown individually and reported on.';
export const LINK_ACTIVITY_SAVED_SUCCESS = 'All Links Activity change saved';
export const LINK_ACTIVITY_DESELECTION_TOAST_REMOVE = 'Remove';
export const LINK_ACTIVITY_DESELECTION_TOAST = 'selection to deselect this data';
export const LINK_ACTIVITY_DESELECTION_TOAST_BTN = 'Open Linked Items Activity';
export const LINKED_ITEM_ACTIVITY = 'Linked Item Activity';

/**
 * | First time user tour
 */
export const NEXT = 'Next';
export const TAKE_A_TOUR = 'Take a guided tour to Report builder';
export const TAKE_A_TOUR_DESC =
	'Report builder is a customizable and flexible tool to helps you examine the data at different levels and answer complex questions about it';
export const START_TOUR = 'Start tour';

/**
 * OMNI OTIF template alert message
 */
export const OMNI_OTIF_ALERT_MESSAGE =
	'For OTIF - Quantity metrics in store and eComm are measured differently ,stores are measured at case level while eComm is measured at eaches/units.';

export const ADD_TO_REPORT = 'Add to report';
/** Save report feature */
export const ACTIVE = 'Active';
export const SAVED = 'Saved';
/**
 * Bucketizing
 */
export const PREVIEW_INIT_MSG = 'To build a report, you need to:';
export const PREVIEW_INIT_MSG_SELECT = 'Select';
export const PREVIEW_INIT_MSG_TIME = 'Time';
export const PREVIEW_INIT_MSG_TIME_AND_WALMART_ITEM_NUMBER = 'Time';
export const PREVIEW_INIT_MSG_DIM = '1 Dimension / 1 Metric';
export const PREVIEW_INIT_MSG_APPLY_FILTER = 'Apply filter on';
export const PREVIEW_READY_CREATE_REPORT = 'Create report ';
export const PREVIEW_READY_BASIC = 'to view your data';
export const PREVIEW_READY = 'Your report is ready to Preview';
export const PREVIEW_READY_CDS = 'Your report can now be created';
export const CREATE_READY = 'Your report is ready to Create';
export const PREVIEW_PIVOT_NOTIFICATION_1 = 'Preview is limited to row option and you can view';
export const PREVIEW_PIVOT_NOTIFICATION_2 = 'the column header format from current screen';
export const PREVIEW_NOTIFICATION_1 = 'Preview is limited to top 50 rows of your report and';
export const PREVIEW_NOTIFICATION_2 = ' last 7 days data of your time selection';

/**
 * Knowledge base
 */
export const HELP = 'Help';
export const TRAINING = 'Training';
export const LUMINATE_CHARTER = 'Scintilla Charter';
export const CONTACT_SALES = 'Contact sales';

/**
 * BASIC TOUR STEPS
 */
export const BASIC_TOUR_STEPS = {
	STEP1: 'Select Time',
	STEP2: 'Add Dimensions',
	STEP3: 'Apply Filter',
	STEP4: 'Create Report',
	GOT_IT: 'Got it!',
	STEP1_DESC: 'Select a ‘Time’ for the report to make it even easier to analyze your data.',
	STEP2_DESC:
		'There are dimensions and metrics available in each data set. Add at least one dimension to create your report.',
	STEP3_DESC: (
		<>
			<span>Apply filters to sort and organize your data with more precision and efficiency.</span>
			<br />
			<br />
			<span>
				P.S. Some data sets are only available to Charter customers. To upgrade today, contact us
				here.
			</span>
		</>
	),
	STEP4_DESC: 'Run and view your report by clicking Create Report.'
};

/**
 * CHARTER TOUR STEPS
 */
export const CHARTER_TOUR_STEPS = {
	STEP1: 'Select Time',
	STEP2: 'Add Dimensions',
	STEP3: 'Apply Filter',
	STEP4: 'Create Report',
	GOT_IT: 'Got it!',
	STEP1_DESC:
		'Selecting time for your report is not required, but it’s very helpful for you analyzing the report.',
	STEP2_DESC:
		'There are dimensions and metrics in each dataset. To create a report, please add at least one dimension to start.',
	STEP3_DESC: 'Narrowing down your data by applying filters to your report.',
	STEP4_DESC:
		'After adding the dimensions/ metrics and time filter, click Preivew to see the results.'
};

/**
 * Filter Form Steps
 */
export const FILTER_FORM_STEPS = {
	STEP1: 'Almost there, review your selections',
	STEP1_DESC:
		'We’ll always show you any selections that require a filter. Add additional filters to selections you’ve already made or hide columns you don’t want displayed.'
};

export const SAVED_RPT_MSG = {
	LIMIT_EXCEED: 'Report cannot be saved since your saved storage is full.',
	SAVING_FAILED: 'Saving report failed. Please try again.',
	REPORT_ADDED: 'Report added to Saved',
	RENAME_FAILED: 'Renaming report failed. Please try again.',
	DELETION_FAILED: 'Deleting report failed. Please try again.',
	STORAGE_FULL: `Storage is full:\u00A0`,
	STORAGE_FULL_EXT: ` you cannot save any report right now. Please clean up space for continue using save
	functionality.`
};
export const KNOWLEDGE_BASE_PATH =
	'knowledgeBase/articles?path=/knowledge-base/WMT-US/SUPPLIER/category-page/CHANNEL_PERFORMANCE/en_us/channel-performance-category-page';
export const TRAINING_RESOURCE_URL = 'https://learn.walmartdataventures.com/app';

/**
 * Placeholder textp
 *
 */
export const PLACEHOLDER_TXT = {
	START_TYPING: 'Start Typing (min 3 characters)',
	VALUES: 'Value(s)',
	LOADING_SUGGESTION: 'Loading Suggestions. Please wait...'
};

/**
 * ECOM Alert Message
 */

export const ECOM_ALERT_MSG = `Kindly pull data at day level by including 'Date' in report, else data is aggregated for given time range.`;

/**
 * New filter design
 */
export const REQUIRED_FILTERS = 'Required';
export const SELECT_FROM_ALL = 'Select from all data list';
export const HEADER_SELECT_FROM_ALL = 'Select from all data list';
export const SELECT_VALUE = 'Select Value';
export const NO_OPTIONAL_FILTER_SELECTED = 'No filters';
export const GUIDE_TO_ADD_OPTIONAL_FILTER1 = 'Adding filter here is optional but can';
export const GUIDE_TO_ADD_OPTIONAL_FILTER2 = 'help you narrow down the result';

/** Item Share */
export const ITEM_SHARE = {
	FEATURE_NAME: 'Item Share',
	ABOUT: ' about',
	I_ACCEPT: 'I accept',
	ITEM_SHARE_INFO: 'Pull all items including Item Share items. ',
	TERMS_CONDITION_TITLE: 'Please review and accept our Item Share policy before continuing.',
	TERMS_CONDITION_BODY:
		'Item and metrics that are enabled via Item Share will be flagged in our data. This data is subject to the Retail Link User Agreement and can only be used solely for the limited purpose indicated in the Item Share application and not for any other purpose. You must delete all Item Share data when Item Share is discontinued. Walmart may discontinue Item Share in its sole discretion with or without notice.',
	META_DATA_MSG: 'Report contains sensitive data from Item Share.',
	ITEM_SHARE_INFO_LINK: `${apiURL}/knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/chp-resources/chp-faqs/en_us/chp-faqs`
};

/**
 * VALID PERSONA
 */

export const PERSONA = {
	MERCHANT: 'MERCHANT',
	SUPPLIER: 'SUPPLIER',
	CATMAN: 'CATMAN',
	BASIC_VENDOR: 'BASIC_VENDOR',
	BASIC_CATMAN: 'BASIC_CATMAN',
	LIMITED_ACCESS_MERCHANT: 'MERCHANT',
	FULL_ACCESS_MERCHANT: 'MERCHANT'
};
export const INTERNAL = 'INTERNAL';
export const EXTERNAL = 'EXTERNAL';
export const STANDARD = 'STANDARD';
export const NO_PERSONA = 'NO_PERSONA';

export const COMPANYNAME = 'COMPANYNAME';

export const LUMINATE_PLANS_LINK = '/plans';
export const EOP_LINK =
	'/knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/dataset-overview/store-sales-inventory/en_us/store-sales-inventory';
export const CHARTER_ONLY_TEMPLATE_HEADER = 'Datasets available in ';
export const CHARTER_ONLY_TEMPLATE_SUBHEADER =
	'Learn more about Walmart Scintilla Charter subscription ';
export const HERE = 'here';
export const USE_THE_DATASET = 'Use this dataset';
export const DATA_FOR_CHARTER_ONLY = 'Data available in Charter only';
export const AVAILABLE_FOR_CHARTER_ONLY = ' is available in Charter only';
export const DATA_PREVIEW = 'Data Preview';

export const SSI_ATTR_LIST = ['carry_option_code', 'carry_status_code'];
export const DC_ATTR_LIST = ['inventory_required_indicator', 'cancel_when_out_indicator'];

export const SHOW_CAL_INPUT = [
	'is equal to',
	'is not equal not',
	'is greater than',
	'is greater than or equal to',
	'is less than',
	'is less than or equal to',
	'Custom',
	'On',
	'After',
	'Before'
];

export const PO_DEFAULT_FILTER_MAP = {
	BUS_DATE: 'bus_date',
	PURCHASE_ORDER_CREATED_TIMESTAMP: 'purchase_order_created_timestamp',
	DO_NOT_SHIP_BEFORE_DATE: 'do_not_ship_before_date',
	MUST_ARRIVE_BY_DATE: 'must_arrive_by_date',
	RECEIVED_DATE: 'received_date'
};

export const PO_DEFAULT_FILTERS = [
	PO_DEFAULT_FILTER_MAP.BUS_DATE,
	PO_DEFAULT_FILTER_MAP.PURCHASE_ORDER_CREATED_TIMESTAMP,
	PO_DEFAULT_FILTER_MAP.DO_NOT_SHIP_BEFORE_DATE,
	PO_DEFAULT_FILTER_MAP.MUST_ARRIVE_BY_DATE,
	PO_DEFAULT_FILTER_MAP.RECEIVED_DATE
];

/** ITEM SHARE MANDATORY SELECTION */
export const ITEM_ACCESS_TYPE = 'Item Access Type';
export const WM_ITEM_NUMBER = 'Walmart Item Number';
export const CATALOG_ITEM_ID = 'Catalog Item ID / EComm Prod ID';
export const WM_ITEM_NUMBER_FIELD = 'walmart_item_number';
export const ITEM_ACCESS_TYPE_FIELD = 'item_access_type';
export const CATALOG_ITEM_ID_FIELD = 'catalog_item_id';

export const ITEM_SHARE_SELECTION = [WM_ITEM_NUMBER, CATALOG_ITEM_ID];

export const VISUAL_HIERARCHY_LABELS = {
	DEPARTMENT: 'Department',
	CATEGORY: 'Category'
};

/** SSI Store trait mandatory filter */
export const SSI_STORE_TRAIT_ATTRS = {
	ATTR_SELECTION_TECHNICAL_NAME: [
		'trait_eff_dt',
		'trait_number',
		'trait_description',
		'trait_exp_dt'
	],
	ATTR_SELECTION_BUSS_NAME: [
		'Trait Effective Date',
		'Trait Number',
		'Trait Description',
		'Trait Expiration Date'
	],
	MENDATORY_FILTER_TECHNICAL_NAME: ['trait_number'],
	MAX_FILTER_VALUE: 30
};
export const SSI_STORE_TRAIT_ADDITION_TOOLTIP = [
	'Heads up! A',
	' required filter ',
	'has been added to your list.',
	'Click to review and apply it before moving on.'
];
export const SSI_STORE_TRAIT_REMOVAL_TOOLTIP =
	'One filter has been removed from Required to Optional section';
export const SSIAllLinkRollupFolders = [
	'Item Info and Item hierarchy',
	'Vendor Information',
	'Pack Size and Dimensions'
];
export const SSIAllLinkRollupViewName = 'vw_chnl_perf_item_roll_up';
export const SSIAllLinkDetailsViewName = 'vw_chnl_perf_item_roll_details';

export const AllLinkRollUp = 'allLinkRollUp';
export const AllLinkRollDetails = 'allLinkRollDetails';
/** ENTERPRISE INVENTORY Template */
// While adding new filter item, insert it after the existing items
export const ENTERPRISE_INVENTORY_DEFAULT_FILTER = ['snap_shot_hour'];
export const EIPreviewTooltipMessage = (
	<>
		<pre style={{ textWrap: 'inherit', marginTop: 0 }}>
			Heads up! A <b>required filter</b> has been added to your list.
		</pre>
		Click to review and apply it before moving on.
	</>
);

/** ORDER FORECAST Template */
export const ORDER_FORECAST_DEFAULT_FILTER = ['DC/Store Number', 'DC/Store Type'];
export const OFGuideLocalStorageFlag = 'doNotShowOFTableGuide';

/** SSI- Enabled for 2 Years */
export const SSI_METRIC_SELECTION = (
	<>
		<span style={{ fontWeight: 'bold' }}>Please note: </span>
		<span>
			In this dataset, when you apply a filter to a metric, it will automatically be added to your
			table. Removing a metric from the table also removes its filter.
		</span>
	</>
);
const helpLinks = charterLinks;
const learnMoreLink = helpLinks.find((data) => data.title === 'Register-sales-learn-more');
export const RS_METRIC_SELECTION = (
	<>
		<span style={{ fontWeight: 'bold' }}>Note: </span>
		<span>
			All sales in the Register Sales dataset are limited to the bought-in-store (BIS) channel. Any
			records (items) with no BIS sales (for the selected time period) will not be shown in reports
			for this dataset&nbsp;–&nbsp;
			<a
				href={`${apiURL}/${learnMoreLink?.path}`}
				target="_blank"
				rel="noopener noreferrer"
				style={{ textDecoration: 'none', color: DARK_PURPLE }}>
				Learn More
			</a>
		</span>
	</>
);

/**
 * Technical Names
 */
export const GREGORIAN_CALENDAR = 'Gregorian Calendar';
export const FCST_WM_YR_WK_NBR = 'fcst_wm_yr_wk_nbr';
export const GREGORIAN_CALENDAR_WEEK = 'gregorian_calendar_week';
export const WALMART_WEEK_START_DATE = 'walmart_week_start_date';
export const BUSINESS_DATE = 'business_date';
export const REPORT_DATE = 'report_date';
export const VISIT_LOCAL_DATE = 'visit_local_date';
export const CAL_ROLL_QTR = 'cal_roll_qtr';
export const CAL_ROLL_WEEK = 'cal_roll_week';
export const CAL_ROLL_DAY = 'cal_roll_day';
export const CAL_ROLL_MONTH = 'cal_roll_month';
export const CAL_ROLL_YEAR = 'cal_roll_year';
export const WM_ROLL_QTR = 'wm_roll_qtr';
export const WM_ROLL_MONTH = 'wm_roll_month';
export const WM_ROLL_YEAR = 'wm_roll_year';
export const WM_ROLL_WEEK = 'wm_roll_week';
export const LAST_WEEKEND_KEY = 'Last Weekend [Fri-Sat-Sun]';
export const YESTERDAY_KEY = 'Yesterday';
export const YEAR_KEY = 'Year';
export const QUARTER_KEY = 'Quarter';
export const MONTH_KEY = 'Month';
export const WEEK_KEY = 'Week';
export const DATE_KEY = 'Date';
export const DATE_KEY_LOWERCASE = 'date';
export const DAY_KEY = 'Day';
export const DAY_KEY_LOWERCASE = 'day';
export const YEAR_TO_DATE_KEY = 'Year to date';
export const FUZZY_DATE_VALUE = '1100/01/01 to 1200/01/01';
export const TO_DATE_KEY = 'to date';
export const FUZZY_OPTIONS = {
	[YESTERDAY_KEY]: 'L1D',
	'Week to date': 'W2D',
	'WMT Week to date': 'W2D',
	'Last week': 'L1W',
	'Last 2 weeks': 'L2W',
	'Last 4 weeks': 'L4W',
	'Last 13 weeks': 'L13W',
	'Last 26 weeks': 'L26W',
	'Last 52 weeks': 'L52W',
	'Last 156 weeks': 'L156W',
	'WMT Last week': 'L1W',
	'WMT Last 2 weeks': 'L2W',
	'WMT Last 4 weeks': 'L4W',
	'WMT Last 13 weeks': 'L13W',
	'WMT Last 26 weeks': 'L26W',
	'WMT Last 52 weeks': 'L52W',
	'WMT Last 104 weeks': 'L104W',
	[LAST_WEEKEND_KEY]: 'LWKND',
	'Month to date': 'M2D',
	'WMT Month to date': 'M2D',
	'Last month': 'L1M',
	'Last 2 months': 'L2M',
	'Last 3 months': 'L3M',
	'Last 6 months': 'L6M',
	'Last 12 months': 'L12M',
	'Quarter to date': 'Q2D',
	'WMT Quarter to date': 'Q2D',
	'Last quarter': 'L1Q',
	'Last 2 quarters': 'L2Q',
	'Last 4 quarters': 'L4Q',
	[YEAR_TO_DATE_KEY]: 'Y2D',
	'WMT Year to date': 'Y2D',
	[YEAR_KEY]: 'L1Y',
	'WMT Last quarter': 'L1Q',
	'WMT Last 2 quarters': 'L2Q',
	'WMT LY Last 4 weeks': 'LYL4W',
	'WMT LY Last 13 weeks': 'LYL13W',
	'WMT LY Last 26 weeks': 'LYL26W',
	'WMT LY Last 52 weeks': 'LYL52W',
	'WMT LLY Last 4 weeks': 'LLYL4W',
	'WMT LLY Last 13 weeks': 'LLYL13W',
	'WMT LLY Last 26 weeks': 'LLYL26W',
	'WMT LLY Last 52 weeks': 'LLYL52W',
	'Last 104 weeks': 'L104W',
	// 'LY Last Months': 'LYL1M',
	// 'LY Last 3 months': 'LYL3M',
	// 'LY Last 6 months': 'LYL6M',
	// 'LY Last 12 months': 'LYL12M',
	// 'LLY Last Months': 'LLYL1M',
	// 'LLY Last 3 months': 'LLYL3M',
	// 'LLY Last 6 months': 'LLYL6M',
	// 'LLY Last 12 months': 'LLYL12M',
	'Last 6 years': 'L6Y'
};

export const WALMART_CALENDER_KEY = 'WMT';

export const FUZZY_CALENDAR = {
	'Walmart Calendar': 'walmart',
	[GREGORIAN_CALENDAR]: 'gregorian'
};

export const MULTI_TIME_SELECTION = 'multi_time_selection';
export const MTS_SELECT_UPTO_SIX = 'Select up to 6 time ranges';
export const MTS_COLUMN_TITLE = 'Multi-time selection';
export const WALMART_CALENDAR = 'Walmart Calendar';
export const VH_MAX_SELECT_TEXT = 'Select up to {NN} {field}';

export const CANNED_REPORT_GEO_TIME_OPTIONS = [
	CAL_ROLL_QTR,
	CAL_ROLL_WEEK,
	CAL_ROLL_MONTH,
	CAL_ROLL_YEAR,
	CAL_ROLL_DAY
];

export const CANNED_REPORT_WAL_TIME_OPTIONS = [
	WM_ROLL_QTR,
	WM_ROLL_MONTH,
	WM_ROLL_YEAR,
	WM_ROLL_WEEK
];
export const CANNED_REPORT_TIME_OPTIONS = [
	...CANNED_REPORT_WAL_TIME_OPTIONS,
	...CANNED_REPORT_GEO_TIME_OPTIONS
];

export const UNAVAILABLE_EOP_TIME_FILTERS = [
	'Custom time',
	`Multi-time Selection for 'Week/Month/Year-to-date' in Walmart week/month/year options`
];

export const CUSTOM_DATE_1 = 'CUSTOM_DATE_1';
export const CUSTOM_DATE_2 = 'CUSTOM_DATE_2';

export const CUSTOM_DATASET_ID = -1;
export const CUSTOM_DATASET_DEFAULT_DESC = 'Build personal dataset by combining tables';
export const CUSTOM_DATASET_DEFAULT_TITLE = 'Custom Dataset';
export const CUSTOM_CREATOR_PLACEHOLDER = 'Creator: Me';
export const CUSTOM_DATASET_DEFAULT_NAME = 'My dataset';
export const CUSTOM_DATASET_ILLUSTRATION =
	'A way to build your own datasets to enable more flexible reporting experience';
export const CDTourFlag = 'CustomDatasetTourDisabled';
export const UNSAVED_DATASET = 'Unsaved dataset';
export const DATASET_TOOLTIP = 'Note: Report created from unsaved dataset cannot be edited later';
export const CUSTOM_TOOLTIP_START = 'Start building custom dataset';
export const CUSTOM_TOOLTIP_SELECT = 'Select tables to your dataset';
export const CUSTOM_TOOLTIP_PREVIEW = 'Preview selected tables';
export const CUSTOM_OKAY_TO_START =
	'Click ‘Okay’ to start building report from this custom dataset';
export const CUSTOM_NAME_DATASET = 'Name your dataset';
export const CUSTOM_EDIT_DATASET = 'CUSTOM_NAME_DATASET';
export const CUSTOM_SHOWME_HOW = 'Show me how';
export const CUSTOM_SHOW_TOOLTIP = 'ShowTooltip';
export const CUSTOM_PREVIEW_ATTR = 'Preview attributes';
export const CONTAINER_PAGE_NOTFOUND = '404 - Not Found!';
export const CUSTOM_GUIDE_CLICK_TO_START = (
	<>
		Click <b>Custom Dataset</b> to start
	</>
);
export const CUSTOM_GUIDE_SELECT_DC = (
	<>
		Try select <b>DC Alignment</b> table to your first dataset
	</>
);
export const CUSTOM_GUIDE_SELECT_SAVE =
	'Datasets will be saved by default. If you’d like to build a one time use dataset, uncheck the Save dataset option. Beware reports created from unsaved dataset cannot be edited later.';
export const CUSTOM_GUIDE_GIVE_NAME =
	'Give your dataset a name so it would be easier for you to find it at the next time.';
export const CUSTOM_GUIDE_DISPLAY_TABLE =
	'All selected tables will be displayed on the right panel for you to preview the selection and double check everything looks good.';
export const GET_CUSTOM_GUIDE_EDIT = (MoreIconTag, props = {}) => {
	return (
		<>
			You can always edit your saved or unsaved custom dataset by clicking the{' '}
			<MoreIconTag {...props} /> icon.
		</>
	);
};

export const ECOMM_INSTOCK_FC_MEASURES = ['fulfilment_center_identifier', 'fulfilment_center_name'];

export const ECOMM_INSTOCK_PERCENTAGE_MEASURES = [
	'ecomm_national_instock_last_year',
	'ecomm_national_instock_this_year'
];

// MTS row vs column
export const PIVOT_COLUMN_LIMIT = 250;
export const PIVOT_MTS_VALUE = 'wm_time_window_week';
export const TIME_ACROSS_MTS_VALUE = 'wm_time_window_week';
export const WALMART_CALENDAR_WEEK = 'walmart_calendar_week';
export const PIVOT_SINGLE_TIME_VALUE_MAP = {
	WMT_CAL_DATE: 'business_date',
	WMT_CAL_DC_DATE: 'inventory_date',
	WMT_CAL_MUMD_DATE: 'mumd_date',
	WMT_CAL_ECOM_INV_DATE: 'report_date',
	WMT_CAL_WEEK: 'walmart_calendar_week',
	WMT_CAL_MONTH: 'walmart_calendar_month',
	WMT_CAL_QTR: 'walmart_calendar_quarter',
	WMT_CAL_YEAR: 'walmart_calendar_year',
	WMT_YEAR_AND_WEEK: 'walmart_year_and_week',
	SNAP_SHOT_HOUR: 'snap_shot_hour'
};
export const PIVOT_SINGLE_TIME_VALUES = [
	// Walmart Calendar time periods
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_DATE,
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_DC_DATE,
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_MUMD_DATE,
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_ECOM_INV_DATE,
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_WEEK,
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_MONTH,
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_QTR,
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_YEAR,
	// DC metric, WMT Week attribute
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_YEAR_AND_WEEK,
	// Hourly Store Inventory, Dimension Hour attribute
	PIVOT_SINGLE_TIME_VALUE_MAP.SNAP_SHOT_HOUR
];
export const PIVOT_AVAILABLE_TEMPLATES = [
	...REGISTER_SALES_LIST,
	...OMNI_TMPT_LIST,
	...STR_TMPT_LIST,
	...DC_TMPT_LIST,
	...OTIF_TMPT_LIST,
	...MUMD_ORDER_LIST,
	...ECOM_INVENTORY,
	...ECOM_SALES_LIST,
	...ENTERPRISE_INVENTORY
];

export const TRAIT_NUMBER = 'Trait Number';
export const TRAIT_NBR = 'trait_nbr';
export const HAS_ALL_OF = 'has all of';
export const HAS_ANY_OF = 'has any of';
export const IS_EQUAL_TO = 'is equal to';
export const CONTAINS = 'contains';
export const INVENTORY_DATE = 'inventory_date';
export const MUMD_DATE = 'mumd_date';
export const SSIContainsOnlyColumns = [
	'Send Trait',
	'Future Send Trait',
	'Omit Trait',
	'Future Omit Trait'
];

export const PREVIEW_STATUS = {
	NO_ERROR: 0,
	FAILURE: 505
};

export const CUSTOM_ATTRIBUTE_VALUE = 'custom_attribute_value';
export const CUSTOM_ATTRIBUTE_NAME = 'custom_attribute_name';
// This is a dummy view name for a custom data set
// Make sure if this changes, it is reflected in all the areas it is being used
export const ABC = 'abc';
// For Custom datasets, the template id is 789
export const TIME_BUSINESS_NAMES = ['Date', 'Week', 'Month', 'Quarter', 'Year'];
export const CATMAN_USER_ID = 'catman_user_id';
export const MOD_ONLY_POPUP_TEXT =
	'Since Mod-only attributes have beel selected as columns and filters, Time component will not be considered, are you sure you want to proceed?';
export const CUSTOM_DATASET = 'Custom Dataset';
export const CDS_NAME_RESTRICTION_ERR = 'Only alpha numeric charaters are allowed';
export const CUSTOM_DATASET_MODAL_SUBHEADING = 'Select table(s) to build your dataset';
export const CUSTOM_DATASET_MODAL_WARNING =
	'*Only reports created from saved dataset can be edited';
export const SELECT_THIS_TABLE = 'Select this table';
export const CUSTOM_DATASET_TABLE_DETAILS_SUBHEADING =
	'View detailed information about the table and data attributes';
export const SELECTED_TABLES = 'Selected tables';
export const ALL_TABLES = 'All tables';
export const TABLE_DETAILS_LABEL = 'Table Details';
export const CDS_LEARN_MORE =
	'/knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/report-builder/custom-datasets/en_us/custom-datasets';
export const CDS_GIVE_FEEDBACK = '/support/ticketCreation';
export const PROTIP_LEARN_MORE =
	'/knowledgeBase/article/content/?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/chp-resources/chp-faqs/en_us/chp-faqs';
export const PROTIP_LEARN_MORE_BASIC =
	'/knowledgeBase/basic/article/?titleLink=knowledge-base-basic-users%2Farticle-landing-page%2Freport-builder-basic-faq';
export const PROTIP_CDS =
	'/knowledgeBase/article/content/?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/report-builder/custom-datasets/en_us/custom-datasets';
export const PROTIP_CDS_BASIC =
	'/knowledgeBase/basic/article/?titleLink=knowledge-base-basic-users%2Farticle-landing-page%2Fcustom-datasets';
export const PROTIP_EOP =
	'/knowledgeBase/article/content/?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/dataset-overview/store-sales-inventory/en_us/store-sales-inventory';
export const PROTIP_EOP_BASIC =
	'/knowledgeBase/basic/article/?titleLink=knowledge-base-basic-users%2Farticle-landing-page%2Fdataset-overview-sample-reports%2Fstore-sales-%26-inventory-dataset';

export const INITIAL_SSI_COMPATIBILITY = {
	dataSet: {},
	incompatibility: {},
	incompatibilityAttr: [],
	incompatibilityAttrCount: {}
};
export const PREVIEW_NOT_AVAILABLE_TOOLTIP =
	'Preview currently not available for Custom Dataset Reports';

export const CUSTOM_DATASET_SEARCH_PLACEHOLDER = 'Find Data table or field name';
export const VISUAL_HIERARCHY_SEARCH_PLACEHOLDER = 'Search department/category/trait number';
export const VISUAL_HIERARCHY_NO_RESULTS_TITLE = 'No trait number selected.';
export const VISUAL_HIERARCHY_NO_RESULTS_DESCRIPTION = 'Please go back and make selection.';
export const LY_PROTIP_TEXT =
	'LY (Last Year) data follows Walmart calendar, beginning in February each year.';
export const OLD_PROTIP_TEXT_104_WEEKS = 'If you need 104 weeks of data. Please refer to this';
export const HELP_ARTICLE = 'help article';
export const FOR_MORE_INFORMATION = 'for more information.';
export const PROTIP_TEXT_104_WEEKS = 'about our last 104 weeks of data';

export const YOUR_SEARCH_DATA =
	'Your searched data is temporarily unavailable in Custom Dataset Beta.';
export const WARNING_104_WEEKS_TEXT =
	'Walmart Date will be removed from report when Last 104 weeks (or) Last 12 months (or) Last 4 quarters (or) WMT Last Year filter is applied.';
export const IS_BEFORE_52_WEEKS = 52;
export const LAST_WEEK = 52;
/**
 *  Time Pivot Options
 */
export const TIME_ACROSS_DATA_DOWN = 'Time Frame in Data Across Down';
export const TIME_FRAME_IN_ROW = 'Time Frame in Row';

/**
 * Variant ID & Variant Description
 * Do not move/reorder the 'variant_id' attribute to any other index
 */
export const VARIANT_ATTRTIBUTES = [
	'variant_id',
	'variant_description',
	'variant_type_id',
	'variant_type_description'
];
export const DEFAULT_VARIANT_SELECTION = 'Walmart Item Number';
export const VARIANT_ATTRIBUTE_ITEM_SHARE_MESSAGE =
	'Variant attribute is applicable to Item Share items only. Item Share toggle has been turned on.';
export const VARIANT_ATTRIBUTE_ITEM_SHARE_CONFIRM = 'VariantAttributeItemShareConfirmFlag';
export const VENDOR_NBR = 'vendor_nbr';
export const VENDOR_NM = 'vendor_nm';

export const STYLE_CONSTANTS = {
	VISIBLE: 'visible',
	HIDDEN: 'hidden'
};
